module.exports = __webpack_public_path__ + "media/images/athletes/1078-a57935483f18eb78a5b18b3aa461bdd7.png";